__turbopack_context__.v({
  "buttonContainer": "FeaturedBestSellers-module-scss-module__QTJZnq__buttonContainer",
  "heading": "FeaturedBestSellers-module-scss-module__QTJZnq__heading",
  "headingContainer": "FeaturedBestSellers-module-scss-module__QTJZnq__headingContainer",
  "icon": "FeaturedBestSellers-module-scss-module__QTJZnq__icon",
  "productsContainer": "FeaturedBestSellers-module-scss-module__QTJZnq__productsContainer",
});
